<template src="./Footer.html"></template>
<style src="./Footer.scss" lang="scss"></style>

<script>
  import Ad from '@/components/Ad/Ad'
  import Link from '@/components/Link/Link'
  import Teaser from '@/components/Teaser/Teaser'

  /**
   * The footer of the page.
   * @vue-prop {Object[]} elements An array of objects containing the elements of the footer
   */
  export default {
    components: {
      'hp-ad': Ad,
      'hp-teaser': Teaser,
      'hp-link': Link
    },
    props: ['elements']
  }
</script>
